<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="800px"
      @close="onClose"
    >
      <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="132px" :inline="false" size="medium">
          <el-form-item label="Ticket Type" prop="workOrderType" required>
            <el-select v-model="form.workOrderType" :disabled="!!form.targetId" placeholder="Select" class="w-50">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Title" prop="title" required>
            <el-input v-model="form.title" />
          </el-form-item>
          <el-form-item label="Content" prop="content" required>
            <el-input v-model="form.content" :rows="5" type="textarea" />
          </el-form-item>
          <el-form-item label="Images" prop="images">
            <el-upload
              ref="upload"
              class=""
              accept="jpg, .jpeg, .png"
              :headers="headers"
              :data="formData"
              :action="action"
              list-type="picture-card"
              :auto-upload="false"
              :on-success="onSuccess"
              :on-exceed="onExceed"
              :on-error="onFail"
              :limit="limit"
            >
              <i class="el-icon-plus text-[#777]" />
            </el-upload>
          </el-form-item>
        </el-form>

      </div>

      <div class="flex justify-center mt-10">
        <div class="mr-6">
          <el-button round class="btn-primary-plain " @click=" visible = false">Cancel</el-button>
        </div>
        <el-button :loading="submiting" round class="btn-primary" type="primary" @click="confirm">Confirm</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { createWorkOrder } from '@/api/user'
export default {
  data() {
    return {
      formData: {
        FileDir: 'uploads',
        fileName: '',
        storeType: 2
      },
      limit: 3,
      action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_UPLOAD_URL,

      visible: false,
      rules: {},
      form: {
        title: '',
        content: '',
        images: '',
        targetId: 0,
        workOrderType: null,
        processedPeople: '',
        processedPeopleName: ''
      },

      // typeOptions: [
      //   { label: 'order', value: 1 },
      //   { label: 'purchase', value: 2 },
      //   { label: 'finance', value: 3 },
      //   { label: 'consult', value: 4 }
      // ],

      submiting: false

    }
  },

  computed: {
    headers() {
      const token = this.$store.getters.token

      return {
        Authorization: (token.tokenHead && token.tokenHead.length > 0 ? token.tokenHead : 'Bearer') +
        ' ' +
        (token.accessToken ? token.accessToken : '')
      }
    },

    typeOptions() {
      return this.form.targetId ? [{ label: 'order', value: 1 }] : [
        // { label: 'inventory', value: 2 },
        // { label: 'finance', value: 3 },
        { label: 'consult', value: 4 }
      ]
    }
  },

  mounted() {

  },

  methods: {
    open(data, fn = null) {
      const form = {
        title: '',
        content: '',
        images: '',
        targetId: 0,
        workOrderType: null
      }

      data = data ? { ...form, ...data } : form

      this.form = data
      this._fn = fn
      this.visible = true
      if (this.$refs.upload) {
        this.$refs.upload.clearValidate()
      }
    },

    async confirm() {
      await this.$refs.form.validate()
      if (this.submiting) return
      this.submiting = true
      try {
        await this.uploadFiles()
        await createWorkOrder({ ...this.form })
        if (this._fn && typeof this._fn === 'function') {
          const data = JSON.parse(JSON.stringify(this.form))
          const res = this._fn(data)
          if (res && res.then) {
            await res
          }
        }
        this.visible = false
      } catch (error) {
        //
      }

      this.submiting = false
    },

    onClose() {
      this.$refs.upload.clearFiles()
    },

    /* 图片上传相关逻辑 */
    onFail(e, fail) {
      // console.log(e, 'fail')
      this.$notify.error('upload fail')
      if (this._reject) {
        this._reject()
      }
    },

    onExceed() {
      this.$notify.error({ message: 'exceed the limit' })
    },

    async uploadFiles() {
      if (!this.$refs.upload.uploadFiles.some(it => it.status === 'ready')) {
        return true
      }
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.$refs.upload.submit()
      })
    },

    onSuccess(res, file, fileList) {
      if (res.code !== 200) {
        file.status = 'ready'
        // console.log(file)
        return this.onFail(res, file)
      }

      const hasFinished = fileList.every(it => {
        // console.log(it)
        return it.status === 'success'
      })

      if (hasFinished && this._resolve) {
        this.form.images = fileList.map(it => {
          return it.response.data.url
        }).join(',')
        // console.log('finised')
        this._resolve()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
